import TasksAPI from 'dashboard/api/tasks';

const state = {
  records: [],
  notificationsTasks: [],
  todayCount: 0,
  overdueCount: 0,
  uiFlags: { isFetching: false, isCreating: false },
};

const getters = {
  getTasks: $state => $state.records,
  getNotificationsTasks: $state => $state.notificationsTasks,
  getTodayCount: $state => $state.todayCount,
  getOverdueCount: $state => $state.overdueCount,
  getTasksUIFlags: $state => $state.uiFlags,
};

const actions = {
  async fetch({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await TasksAPI.list(params);
      commit('SET_TASKS', data.tasks || []);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async fetchNotifications({ commit }) {
    const { data } = await TasksAPI.notifications();
    commit('SET_NOTIFICATIONS', data);
    return data;
  },

  async create({ commit, dispatch }, payload) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await TasksAPI.create(payload);
      commit('UPSERT_TASK', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update(_, { id, payload }) {
    const { data } = await TasksAPI.update(id, payload);
    return data;
  },

  async remove({ commit }, id) {
    await TasksAPI.remove(id);
    commit('REMOVE_TASK', id);
  },

  async complete({ commit }, id) {
    const { data } = await TasksAPI.complete(id);
    commit('UPSERT_TASK', data);
    return data;
  },

  async reopen({ commit }, id) {
    const { data } = await TasksAPI.reopen(id);
    commit('UPSERT_TASK', data);
    return data;
  },
};

const mutations = {
  SET_UI_FLAG(_state, flags) {
    _state.uiFlags = { ..._state.uiFlags, ...flags };
  },
  SET_TASKS(_state, tasks) {
    _state.records = tasks;
  },
  SET_NOTIFICATIONS(_state, data) {
    _state.notificationsTasks = data.tasks || [];
    _state.todayCount = data.today_count || 0;
    _state.overdueCount = data.overdue_count || 0;
  },
  UPSERT_TASK(_state, task) {
    const idx = _state.records.findIndex(t => t.id === task.id);
    if (idx >= 0) _state.records.splice(idx, 1, task);
    else _state.records.unshift(task);
  },
  REMOVE_TASK(_state, id) {
    _state.records = _state.records.filter(t => t.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
